import { initialBlotterConfiguration } from './BlotterConfiguration';
import { WidgetType } from 'widgets/WidgetType';
import { buildConfigReducerWithGridSupport } from 'widgets/store/grid/reducer';

export const blotterConfigReducer = buildConfigReducerWithGridSupport(
    WidgetType.BLOTTER,
    initialBlotterConfiguration
);
